import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';
import { PossibleFeatures } from 'tradera/apps/syi/state/reducers/fees';

const updatePrices = () => (dispatch, getState) => {
    const featureFees = [];
    const state = getSyiSlice(getState());

    if (state.price.reservePrice) {
        featureFees.push(PossibleFeatures.reservePrice);
    }

    if (state.extraFeatures.displayHighlighted) {
        featureFees.push(PossibleFeatures.highlight);
    }

    if (state.extraFeatures.displayPromoted) {
        featureFees.push(PossibleFeatures.rankUp);
    }

    dispatch({
        type: 'SET_CHOSEN_EXTRA_FEATURES',
        payload: featureFees
    });
};

export default {
    updatePrices
};
